/* ============================================================
 * RECARO Product Switcher
 * 統合商品ページ /products/recaro-xenon-axion 用の
 * モデル切替・カラー切替・variant同期ロジック。
 *
 * ComChat は iframe 内で完結しており、このスクリプトは
 * Shopify標準の cart-add form を更新するだけ。
 * ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-rc-product]');
  if (!root) return;

  const productData = JSON.parse(
    document.getElementById('rc-product-json').textContent
  );

  // option index 0 = 製品, index 1 = 色
  const OPT_MODEL = 0;
  const OPT_COLOR = 1;

  const CDN = 'https://cdn.shopify.com/s/files/1/0920/2027/7566/files/';

  // Neutral fallback per model (中立的なフレッシュブラック写真。
  // 専用色画像がないバリアント選択時のオレンジ誤認を防ぐ)
  const MODEL_NEUTRAL = {
    'キセノン 1（0-7歳向けチャイルドシート）': CDN + 'product01_sub_img_04.webp',
    'アクシオン 1（3-12歳向けジュニアシート）': CDN + 'product02_sub_img_03.webp',
  };

  // Color-specific product photos per model
  const COLOR_IMAGES = {
    'キセノン 1（0-7歳向けチャイルドシート）': {
      'バイブラントオレンジ': CDN + 'product01_sub_img_08.webp',
      'エレガントベージュ': CDN + 'product01_sub_img_02.webp',
      'エピックグリーン': CDN + 'product01_sub_img_03.webp',
      'フレッシュブラック': CDN + 'product01_sub_img_04.webp',
      'ギャラントグレー': CDN + 'product01_sub_img_05.webp',
      'カームブルー': CDN + '01_db1aa561-7b5e-49c6-bf7c-a4f64670c0d4.png?v=1748381878',
      'ワウピンク': CDN + '01_816dab61-3699-4b39-a543-7797a358f9ec.png?v=1748381905',
    },
    'アクシオン 1（3-12歳向けジュニアシート）': {
      'カームブルー': CDN + 'product02_sub_img_01.webp',
      'エピックグリーン': CDN + 'product02_sub_img_02.webp',
      'フレッシュブラック': CDN + 'product02_sub_img_03.webp',
      'ギャラントグレー': CDN + 'product02_sub_img_04.webp',
      'エレガントベージュ': CDN + 'elegant_beige_1.webp',
      'ハローグリーン': CDN + 'product02_sub_img_06.webp',
      'バイブラントオレンジ': CDN + 'product02_sub_img_08.webp',
      'ワウピンク': CDN + 'product02_sub_img_09.webp',
    },
  };

  // Model-specific angle/feature gallery shots
  const GALLERY_ANGLES = {
    'キセノン 1（0-7歳向けチャイルドシート）': [
      { src: CDN + 'product01_intro_img_08.webp?v=1744703701', alt: '360度回転' },
      { src: CDN + 'product01_intro_img_02.webp?v=1744703701', alt: '3段階リクライニング' },
      { src: CDN + 'product01_intro_img_03.webp?v=1744703700', alt: 'モジュール型新生児クッション' },
      { src: CDN + 'product01_intro_img_05.webp?v=1744703700', alt: '心地よい通気システム' },
      { src: CDN + 'product01_intro_img_01.webp?v=1744703701', alt: '台形側面衝突保護' },
    ],
    'アクシオン 1（3-12歳向けジュニアシート）': [
      { src: CDN + 'product02_intro_img_02.webp', alt: '広々とした座席設計' },
      { src: CDN + 'product02_intro_img_03.webp', alt: '柔軟な人間工学設計' },
      { src: CDN + 'product02_intro_img_05.webp', alt: '心地よい通気システム' },
      { src: CDN + 'product02_intro_img_04.webp', alt: '軽量設計' },
      { src: CDN + 'product02_intro_img_01.webp', alt: '台形側面衝突保護' },
    ],
  };

  function getColorImage(model, color) {
    if (COLOR_IMAGES[model] && COLOR_IMAGES[model][color]) {
      return COLOR_IMAGES[model][color];
    }
    return MODEL_NEUTRAL[model] || null;
  }

  // 入荷待ち（発送遅延）カラーの発送目安ラベル。モデル×カラーごとに設定する。
  // 該当しないモデル×カラーは DEFAULT_SHIPPING_LABEL を返す。
  // （sections/main-product-clean.liquid の initial_shipping 分岐も合わせて更新すること）
  // ※該当カラーを実際に「選択・購入可能」にするには、Shopify側でそのバリアントを
  //   在庫切れ時も販売継続（oversell）に設定する必要がある（未設定だとスウォッチは無効表示）。
  const DEFAULT_SHIPPING_LABEL = '1週間以内発送';
  // 2026-08-02 キセノン1エレガントベージュ売り切れ。9月中旬入荷予定。
  const LATE_SHIPPING = {
    'キセノン 1（0-7歳向けチャイルドシート）': {
      'エレガントベージュ': '9月中旬目処入荷',
    },
  };

  function getShippingLabel(model, color) {
    const byModel = LATE_SHIPPING[model];
    if (byModel && byModel[color]) return byModel[color];
    return DEFAULT_SHIPPING_LABEL;
  }

  // Build map: { modelTitle: { colorTitle: variant } }
  const variantMap = {};
  productData.variants.forEach((v) => {
    const model = v.options[OPT_MODEL];
    const color = v.options[OPT_COLOR];
    if (!variantMap[model]) variantMap[model] = {};
    variantMap[model][color] = v;
  });

  // State
  const state = {
    model: null,
    color: null,
    qty: 1,
    activeThumb: 'color', // 'color' or angle index (0..n)
  };

  // Initialize from URL ?variant= or first available
  const params = new URLSearchParams(location.search);
  const initialVariantId = parseInt(params.get('variant'), 10);
  let initialVariant =
    productData.variants.find((v) => v.id === initialVariantId) ||
    productData.variants.find((v) => v.available) ||
    productData.variants[0];
  state.model = initialVariant.options[OPT_MODEL];
  state.color = initialVariant.options[OPT_COLOR];

  function formatJPY(cents) {
    const yen = Math.round(cents / 100);
    return '¥' + yen.toLocaleString('ja-JP');
  }

  function currentVariant() {
    const byModel = variantMap[state.model];
    if (!byModel) return null;
    return byModel[state.color] || null;
  }

  function renderThumbs() {
    const wrap = root.querySelector('[data-rc-thumbs]');
    if (!wrap) return;
    const colorSrc = getColorImage(state.model, state.color);
    const angles = GALLERY_ANGLES[state.model] || [];
    const items = [
      { src: colorSrc, alt: state.model + ' ' + state.color, key: 'color' },
      ...angles.map((a, i) => ({ src: a.src, alt: a.alt, key: i })),
    ];
    wrap.innerHTML = items
      .map(
        (it) =>
          `<button class="rc-gallery__thumb" type="button" data-rc-thumb="${it.key}" aria-current="${it.key === state.activeThumb ? 'true' : 'false'}"><img src="${it.src}" alt="${it.alt}" loading="lazy"></button>`
      )
      .join('');
  }

  function updateUI() {
    const v = currentVariant();

    // Model buttons aria-pressed
    root.querySelectorAll('[data-rc-model-btn]').forEach((btn) => {
      btn.setAttribute(
        'aria-pressed',
        btn.dataset.rcModelBtn === state.model ? 'true' : 'false'
      );
    });

    // Color swatches: aria-pressed + disabled based on availability
    root.querySelectorAll('[data-rc-color-sw]').forEach((sw) => {
      const c = sw.dataset.rcColorSw;
      const variantForThis = variantMap[state.model]?.[c];
      const isAvailable = variantForThis && variantForThis.available;
      sw.setAttribute('aria-pressed', c === state.color ? 'true' : 'false');
      if (isAvailable) {
        sw.removeAttribute('disabled');
      } else if (variantForThis) {
        // exists but out of stock
        sw.setAttribute('disabled', '');
      } else {
        // not exists for this model
        sw.setAttribute('disabled', '');
      }
    });

    // Selected color label
    const colorLabel = root.querySelector('[data-rc-color-label]');
    if (colorLabel) colorLabel.textContent = state.color;

    // Selected model display
    const modelMeta = root.querySelector('[data-rc-model-meta]');
    if (modelMeta) {
      const modelInfo = root.querySelector(
        `[data-rc-model-info="${state.model}"]`
      );
      if (modelInfo) modelMeta.textContent = modelInfo.dataset.rcModelInfoText;
    }

    // Series + name displays (per-model)
    root.querySelectorAll('[data-rc-show-for-model]').forEach((el) => {
      el.hidden = el.dataset.rcShowForModel !== state.model;
    });

    // Price
    if (v) {
      const priceEl = root.querySelector('[data-rc-price]');
      if (priceEl) priceEl.textContent = formatJPY(v.price);
    }

    // Hidden form id
    if (v) {
      const idInput = root.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
    }

    // CTA enable/disable
    const cta = root.querySelector('[data-rc-cta]');
    if (cta) {
      if (!v || !v.available) {
        cta.disabled = true;
        cta.textContent = '在庫切れ';
      } else {
        cta.disabled = false;
        cta.textContent = 'カートに追加';
      }
    }

    // Shipping schedule label
    const shippingEl = root.querySelector('[data-rc-shipping]');
    if (shippingEl) {
      shippingEl.textContent = getShippingLabel(state.model, state.color);
    }

    // Render thumbnails (color shot first, then angle shots for current model)
    renderThumbs();

    // Main image: depends on activeThumb
    const mainImg = root.querySelector('[data-rc-main-image]');
    if (mainImg) {
      if (state.activeThumb === 'color') {
        const src = getColorImage(state.model, state.color);
        if (src) {
          mainImg.src = src;
          mainImg.alt = state.model + ' ' + state.color;
        }
      } else {
        const angle = (GALLERY_ANGLES[state.model] || [])[state.activeThumb];
        if (angle) {
          mainImg.src = angle.src;
          mainImg.alt = angle.alt;
        }
      }
    }

    // URL update (no reload)
    if (v && window.history && window.history.replaceState) {
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  // Event delegation
  root.addEventListener('click', (e) => {
    const modelBtn = e.target.closest('[data-rc-model-btn]');
    if (modelBtn) {
      const newModel = modelBtn.dataset.rcModelBtn;
      if (newModel === state.model) return;
      state.model = newModel;
      // If current color isn't available for new model, pick first available
      const colorsForModel = Object.keys(variantMap[newModel] || {});
      if (!variantMap[newModel]?.[state.color]) {
        const firstAvailable = colorsForModel.find(
          (c) => variantMap[newModel][c].available
        );
        state.color = firstAvailable || colorsForModel[0];
      }
      state.activeThumb = 'color';
      updateUI();
      return;
    }

    const swatch = e.target.closest('[data-rc-color-sw]');
    if (swatch && !swatch.disabled) {
      const newColor = swatch.dataset.rcColorSw;
      if (newColor === state.color) return;
      state.color = newColor;
      state.activeThumb = 'color';
      updateUI();
      return;
    }

    const thumb = e.target.closest('[data-rc-thumb]');
    if (thumb) {
      const key = thumb.dataset.rcThumb;
      state.activeThumb = key === 'color' ? 'color' : parseInt(key, 10);
      updateUI();
      return;
    }

    // Quantity stepper
    const qtyBtn = e.target.closest('[data-rc-qty]');
    if (qtyBtn) {
      const dir = qtyBtn.dataset.rcQty;
      const input = root.querySelector('input[name="quantity"]');
      if (!input) return;
      let qty = parseInt(input.value, 10) || 1;
      if (dir === 'plus') qty = Math.min(qty + 1, 10);
      else if (dir === 'minus') qty = Math.max(qty - 1, 1);
      input.value = qty;
      state.qty = qty;
      return;
    }

    // Accordion toggle
    const accBtn = e.target.closest('[data-rc-accordion-btn]');
    if (accBtn) {
      const wrap = accBtn.closest('.rc-accordion');
      if (!wrap) return;
      const expanded = wrap.getAttribute('aria-expanded') === 'true';
      wrap.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const body = wrap.querySelector('.rc-accordion__body');
      if (body) body.hidden = expanded;
      return;
    }
  });

  // Quantity manual input
  const qtyInput = root.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('change', () => {
      let qty = parseInt(qtyInput.value, 10) || 1;
      qty = Math.max(1, Math.min(10, qty));
      qtyInput.value = qty;
      state.qty = qty;
    });
  }

  // Initial render
  updateUI();
})();
